<script setup>
import channelsightWidget from './js/channelsight-widget.js';
import dataModel from './js/model.js';
import csModal from './components/csModal.vue';
import hero from './components/hero.vue';
import inlineRetailers from './components/inlineRetailers.vue';
import carousel from './components/carousel.vue';
import intro from './components/intro.vue';
import videosection from './components/videosection.vue';
import terms from './components/terms.vue';

//invoke the channelsight widget, if needed
channelsightWidget();

//grab URL parameter to determine experience
let params = new URLSearchParams(document.location.search);
let brandContextParam = params.get("brandContext");

//parse URL parameter ready to pass to component
var brandContext = (!brandContextParam == '' && brandContextParam <= Object.keys(dataModel).length) ? brandContext=brandContextParam : brandContext='3';

function debounce(func, wait, immediate) {
    var timeout;
    return function () {
        var context = this,
            args = arguments;
        var later = function () {
            timeout = null;
            if (!immediate)
                func.apply(context, args);

        };
        var callNow = immediate && !timeout;
        clearTimeout(timeout);
        timeout = setTimeout(later, wait);
        if (callNow)
            func.apply(context, args);

    };
};
var lastWidth = $(window).width();
var resizeReload = debounce(function () {
    if ($(window).width() != lastWidth) {
        {
            location.reload();
        }
    }
}, 250);
$(window).resize(function () {
    resizeReload();
})
$(document).on('click', '.scroll-to-top', function() {
    $("html").animate({ scrollTop: 0 }, "slow");
})

</script>

<template>
  <hero :brandExperience="brandContext" />
  <inlineRetailers :brandExperience="brandContext" />
  <intro :brandExperience="brandContext" />
  <carousel :brandExperience="brandContext" :iteration="'1'"/>
  <videosection />
  <carousel :brandExperience="brandContext" :iteration="'2'"/>
  <terms :brandExperience="brandContext"/>
  
</template>

<style>
body, html {
  height: 100%;
  margin: 0;
}
#app {
  height: 100%;
  text-align: center;
}
.noselect {
  -webkit-touch-callout: none; /* iOS Safari */
    -webkit-user-select: none; /* Safari */
     -khtml-user-select: none; /* Konqueror HTML */
       -moz-user-select: none; /* Old versions of Firefox */
        -ms-user-select: none; /* Internet Explorer/Edge */
            user-select: none; /* Non-prefixed version, currently
                                  supported by Chrome, Edge, Opera and Firefox */
}

</style>
